import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { auctionType } from '../../types';
import './_styles_/BidsInputParamConfiguration.css';
import Number from '../Number';
import BidsInputParamConfigurationForm from './BidsInputParamConfigurationForm';
import {
    joinClassNames,
    onActionKey,
} from '../../utils';
import {
    getBiddingType,
    OPEN,
    SLOTTED,
} from '../../utils/BiddingTypes';

BidsInputParamConfiguration.propTypes = {
    auction: auctionType.isRequired,
    onQuantityStepChange: PropTypes.func.isRequired,
    onPriceStepChange: PropTypes.func.isRequired,
    onQuantityStepValidation: PropTypes.func.isRequired,
    onPriceStepValidation: PropTypes.func.isRequired,
    isQuantityStepValid: PropTypes.bool.isRequired,
    isPriceStepValid: PropTypes.bool.isRequired,
    isConflictWithBiddingUserConfigurationQuantityStep: PropTypes.bool.isRequired,
    isConflictWithBiddingUserConfigurationPriceStep: PropTypes.bool.isRequired,
    priceStep: PropTypes.number.isRequired,
    quantityStep: PropTypes.number,
};

function BidsInputParamConfiguration(props) {
    const {
        auction,
        onQuantityStepChange,
        onPriceStepChange,
        onQuantityStepValidation,
        onPriceStepValidation,
        isQuantityStepValid,
        isPriceStepValid,
        quantityStep = null,
        priceStep,
        isConflictWithBiddingUserConfigurationQuantityStep,
        isConflictWithBiddingUserConfigurationPriceStep,
    } = props;
    const { t } = useTranslation();
    const biddingType = getBiddingType(auction.biddingType);
    const [isInputParamConfigurationVisible, setInputParamConfigurationVisibility] = useState(false);
    const toggleInputParamConfiguration = () => {
        if (isPriceStepValid && (biddingType.is(SLOTTED) || isQuantityStepValid)) {
            setInputParamConfigurationVisibility(!isInputParamConfigurationVisible);
        }
    };
    return (
        <div className="auction-bids--bids-input-param-container">
            <div
                className={joinClassNames(
                    'auction-bids--place-bid--configuration--cog',
                    isInputParamConfigurationVisible && 'active',
                    (!isPriceStepValid || (biddingType.is(SLOTTED) && !isQuantityStepValid)) && 'error',
                    (isConflictWithBiddingUserConfigurationQuantityStep || isConflictWithBiddingUserConfigurationPriceStep) && 'warning',
                )}
                onClick={toggleInputParamConfiguration}
                onKeyUp={onActionKey(toggleInputParamConfiguration)}
                role="button"
                tabIndex="0"
                title={t('auctions.bids-list.input-parameter-configuration')}
            >
                <FontAwesomeIcon icon="cog" />
                <div className="auction-bids--place-bid--configuration--cog--hints">
                    {biddingType.is(OPEN) && (
                        <span className="auction-bids--place-bid--configuration--cog--hints--quantity-step">
                            {t('auctions.bids-list.quantity-step-abbr')}: <Number value={quantityStep} />
                        </span>
                    )}
                    <span className="auction-bids--place-bid--configuration--cog--hints--price-step">
                        {t('auctions.bids-list.price-step-abbr')}: <Number value={priceStep} fractionDigits={2} />
                    </span>
                </div>
            </div>
            {isInputParamConfigurationVisible && (
                <BidsInputParamConfigurationForm
                    auction={auction}
                    onQuantityStepChange={onQuantityStepChange}
                    onPriceStepChange={onPriceStepChange}
                    onQuantityStepValidation={onQuantityStepValidation}
                    onPriceStepValidation={onPriceStepValidation}
                    quantityStep={quantityStep}
                    priceStep={priceStep}
                    isConflictWithBiddingUserConfigurationQuantityStep={isConflictWithBiddingUserConfigurationQuantityStep}
                    isConflictWithBiddingUserConfigurationPriceStep={isConflictWithBiddingUserConfigurationPriceStep}
                />
            )}
        </div>
    );
}

export default BidsInputParamConfiguration;
